import { DeviceType } from '@horasys/bellplus/common/types';
import { DeviceTypesSuccessAction } from 'store/actions/deviceTypeActions';
import { GET_DEVICE_TYPES_SUCCESS } from '../actions/types';

const deviceType: DeviceType = {} as DeviceType;

export interface DeviceTypeStore {
	list: Array<any>;
	deviceType: DeviceType;
}
const initialState: DeviceTypeStore = {
	list: [],
	deviceType: deviceType,
};

export const deviceTypeReducer = (
	state = initialState,
	action: DeviceTypesSuccessAction,
): DeviceTypeStore => {
	switch (action.type) {
		case GET_DEVICE_TYPES_SUCCESS: {
			return {
				...state,
				list: action.payload,
			};
		}
		default: {
			return {
				...state,
			};
		}
	}
};
